<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->

<!--<ng-template #rt let-r="result" let-t="term">-->
  <!--{{ r}}-->
<!--</ng-template>-->
<div class="input-group">
  <span class="input-group-addon"><span class="fa fa-search">&nbsp;</span>{{searchLabel}} </span>

  <input id="typeahead-template" type="text" class="form-control" style="width: 200px;" [(ngModel)]="model" (selectItem)="itemSelected($event)" [ngbTypeahead]="search" />
  <!--<input id="typeahead-template" type="text" class="form-control" style="width: 200px;" [(ngModel)]="model" [ngbTypeahead]="search" [resultTemplate]="rt" [inputFormatter]="formatter" />-->
  <button id="reset-typeahead" type="button" class="btn btn-secondary" (click)="itemsReseted($event)">
    <i class="fa fa-refresh"></i> Reset
  </button>
</div>
